<template>
  <div class="cont" v-if="active" ref="dragContent">
    <div class="mask" @click="shut"></div>
    <ul class="keyboard" @mousedown="tagDraggable($event)">
      <li
        v-for="(key, index) in keyList"
        :key="index"
        track-by="$index"
        :class="{
          delete: key === 'Delete',
          tab: key === 'Tab',
          capslock: key === 'Caps',
          enter: key === 'Enter',
          shift: key === 'Shift',
          space: key === 'Space',
          shifted: key === 'Shift' && hasShifted,
          capsed: key === 'Caps' && hasCapsed,
        }"
        v-text="key"
        @click="clickKey(key)"
      ></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      keyList: [],
      normalKeyList: [],
      shiftedKeyList: [],
      capsedKeyList: [],
      hasShifted: false,
      hasCapsed: false,
      keyvalue: "",
      keyval: "",
      val: "",
      value: "",
      keyVal: "",
      active: null,
    };
  },
  watch: {
    show: {
      handler(newVal) {
        this.active = this.show;
        console.log(this.active);
      },
      immediate: true,
    },
  },
  created() {
    this.ready();
  },
  methods: {
    shut() {
      this.active = false;
    },
    clickKey(key) {
      switch (key) {
        case "Delete":
          let kbt = this.keyvalue;
          this.keyvalue = kbt.length ? kbt.substring(0, kbt.length - 1) : kbt;
          break;

        case "Tab":
          this.keyvalue += "\t";
          break;

        case "Enter":
          if (!this.$parent.lsh2) {
            this.$parent.confirmFn();
          }
          if (this.$parent.confirmFnT) {
            this.$parent.confirmFnT();
          }
          if (this.$parent.confirmFn1) {
            this.$parent.confirmFn1();
          }

          break;

        case "Space":
          this.keyvalue += " ";
          break;

        case "Caps":
          this.hasCapsed = !this.hasCapsed;
          this.keyList = this.hasCapsed
            ? this.normalKeyList
            : this.capsedKeyList;
          break;

        case "Shift":
          this.hasShifted = !this.hasShifted;
          this.keyList = this.hasShifted
            ? this.shiftedKeyList
            : this.normalKeyList;
          break;

        default:
          this.keyvalue += key;
          this.keyval += key;
          this.val += key;
          this.value += key;
          this.keyVal += key;
          break;
      }
      this.$emit("updatekey", this.keyvalue);
      this.$emit("getval", this.val);
      this.$emit("getValue", this.keyval);
      this.$emit("getkey", this.value);
      this.$emit("getkeyval", this.keyVal);
    },
    ready() {
      let normalKeyList = [
          "`",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "0",
          "-",
          "=",
          "Delete",
          "Tab",
          "q",
          "w",
          "e",
          "r",
          "t",
          "y",
          "u",
          "i",
          "o",
          "p",
          "[",
          "]",
          "\\",
          "Caps",
          "a",
          "s",
          "d",
          "f",
          "g",
          "h",
          "j",
          "k",
          "l",
          ";",
          "'",
          "Enter",
          "Shift",
          "z",
          "x",
          "c",
          "v",
          "b",
          "n",
          "m",
          ",",
          ".",
          "/",
          "Shift",
          "Space",
        ],
        shiftedKeyList = [
          "~",
          "!",
          "@",
          "#",
          "$",
          "%",
          "^",
          "&",
          "*",
          "(",
          ")",
          "_",
          "+",
          "Delete",
          "Tab",
          "Q",
          "W",
          "E",
          "R",
          "T",
          "Y",
          "U",
          "I",
          "O",
          "P",
          "{",
          "}",
          "|",
          "Caps",
          "A",
          "S",
          "D",
          "F",
          "G",
          "H",
          "J",
          "K",
          "L",
          ":",
          '"',
          "Enter",
          "Shift",
          "Z",
          "X",
          "C",
          "V",
          "B",
          "N",
          "M",
          "<",
          ">",
          "?",
          "Shift",
          "Space",
        ],
        capsedKeyList = [
          "`",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "0",
          "-",
          "=",
          "Delete",
          "Tab",
          "Q",
          "W",
          "E",
          "R",
          "T",
          "Y",
          "U",
          "I",
          "O",
          "P",
          "[",
          "]",
          "\\",
          "Caps",
          "A",
          "S",
          "D",
          "F",
          "G",
          "H",
          "J",
          "K",
          "L",
          ";",
          "'",
          "Enter",
          "Shift",
          "Z",
          "X",
          "C",
          "V",
          "B",
          "N",
          "M",
          ",",
          ".",
          "/",
          "Shift",
          "Space",
        ];

      this.keyList = this.capsedKeyList = capsedKeyList;
      this.shiftedKeyList = shiftedKeyList;
      this.normalKeyList = normalKeyList;
    },
    tagDraggable(e) {
      // let odiv = e.target; //获取目标元素
      // //算出鼠标相对元素的位置
      // let disX = e.clientX - odiv.offsetLeft;
      // let disY = e.clientY - odiv.offsetTop;
      // document.onmousemove = (e) => {
      //   //鼠标按下并移动的事件
      //   //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
      //   let left = e.clientX - disX;
      //   let top = e.clientY - disY;
      //   //绑定元素位置到positionX和positionY上面
      //   this.positionX = top;
      //   this.positionY = left;
      //   //移动当前元素
      //   odiv.style.left = left + "px";
      //   odiv.style.top = top + "px";
      // };
      // document.onmouseup = (e) => {
      //   document.onmousemove = null;
      //   document.onmouseup = null;
      // };
      // 获取目标元素
      e = e || window.event;
      let odiv = e.target;
      if (!odiv.className.includes("keyboard")) return;
      // 算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      document.onmousemove = (e) => {
        //鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        e = e || window.event;
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        let width = this.$refs.dragContent.offsetWidth;
        let height = this.$refs.dragContent.offsetHeight;
        //   // 标签不能移动到容器外
        left < 0 && (left = 0);
        left > width && (left = width - odiv.offsetWidth);
        top < 0 && (top = 0);
        top > height && (top = height - odiv.offsetHeight);
        // 移动当前元素
        odiv.style.left = `${left}px`;
        odiv.style.top = `${top}px`;
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
};
</script>

<style lang="less" scoped>
.cont {
  position: fixed;
  height: 100%;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // transform: translate(-50%, -50%);
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1);
  }
}
.keyboard {
  position: absolute;
  top: 65%;
  // bottom: 0%;
  left: 50%;
  // right: ;
  transform: translateX(-50%);
  width: 460px;
  margin: 10px auto;
  padding: 0;
  list-style: none;
  user-select: none;
  background-color: gray;
  padding-left: 5px;
  padding-top: 5px;
  cursor: move;
  li {
    float: left;
    margin: 0 5px 5px 0;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #fff;
    border: 1px solid #e5e5e5;
    color: #000;
    border-radius: 5px;
    font-size: 12px;

    &:hover {
      position: relative;
      border-color: gray;
      cursor: pointer;
    }
    &:active {
      top: 1px;
      left: 1px;
    }
  }

  .tab,
  .delete {
    width: 2rem;
  }
  .capslock {
    width: 60px;
  }
  .enter {
    width: 65px;
  }
  .shift {
    width: 78px;
  }
  .space {
    clear: left;
    width: 455px;
  }
  .shifted {
    position: relative;
    top: 1px;
    left: 1px;
    border-color: #e5e5e5;
    cursor: pointer;
  }
  .capsed {
    position: relative;
    top: 1px;
    left: 1px;
    border-color: #e5e5e5;
    cursor: pointer;
  }
}
</style>